import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { generateVideo } from '../../api/campaigns';

export const RestoreVideoButton = ({ getCampaigns, campaign }) => {
  const [loading, setLoading] = useState(false);
  
  const restoreVideo = async ({ _id }) => {
    setLoading(true);
    try {
      await generateVideo(_id);
      toast.success('Video generation request sent successfully');
      getCampaigns();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to generate video');
    } finally {
      setLoading(false);
    }
  };

  return !loading ? (
    <Button
      variant="outlined"
      color="secondary"
      disabled={loading}
      onClick={() => restoreVideo(campaign)}
    >
      Restore Video
    </Button>
  ) : (
    <FontAwesomeIcon icon={faSpinner} size="lg" spin />
  );
};
